var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgForm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "url(#pattern10)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern10",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1174_2229",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1174_2229",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAABmJLR0QA/wD/AP+gvaeTAAACjklEQVR4nO3cP2sUQRjH8edE7pZjT886hBPEKrYWihbiBbGwUOQglQcWeQXWYus7SCHYBURtBBGiWGgQbCWViASxz59LSK6ykBQxWbnMPc/sszvfT7nHPbvwY2ae2WVXBAAAAAAAAAAAAEC6GlqFeufnVqUhV7XqVczn9Z9r1zUKndIoIiKScBgiIte0Cp3WKnTg+5cV7ZKuXbwyr1pPb4RAhfoIOXD51j3Z2Nq2Kj+R3uyMvH/xvNRrOCmzQDa2tpObvjQwZTlDIM4QSID+YGhWm0ACrP/6bVabQAL0ZmfMapt1WUXm5u/IeLQX+7RBmnkmaytvjhy3bKWjBzIe7cmNZ4uxTxvk48Ol6OdkygrAou4Mi3pCCCSAZZdFIAFq1WU186yU7iVEM8+inzN6IMf19VXTHwzNRglTVgC6rIQke+uk6LZI2ZK9deK1sWDKcoZAnDELxHI3W2dma0hRn+5lY1jGpm8SbAydMZuyLJ8Z1JlZIJa72Tqjy3KGQJwhEGfYhzgTfR9y6eZd2d8dTVU7a3fk24fXx/7WHwzVGooyXmeIvg/Z3x3JwpPlqWosP14o/K1q74P8izXEGQJxhkCcIRBnoi/qRd4+fSCbO+NDx7p5S24/mn6RDu28kuiyimzujOXH0v1Dxy4svlSpXaXOiynLGQJxhkCccbOGdPPWkTWjm7dKupryuAlEo5s6iUk6r6S7rNi8dl6sIc4QiDME4ozZGlL0UkvW7vz3ecYksnZnqv97ZhZIUQdT9KQPfzFlOUMgzhBIAN5Td8ZyU0kgzph1WefOnlH/yLA1D5+VNQvk67tXVqVrjSnLGfURUrVpyhvNEbKqWKtSGiKfyr4GAAAAAAAAAAAAAHXwB/ltlMZfxc2KAAAAAElFTkSuQmCC"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForm);
export default __webpack_public_path__ + "static/media/form.7cc94ce3.svg";
export { ForwardRef as ReactComponent };